import * as React from 'react'
import 'katex/dist/katex.min.css';
import styled from "styled-components";
import Latex from 'react-latex-next';
const MQNo = styled.p`
    text-align: right;
    font-size: 16px;
    font-weight: 500;
    margin-left: auto;
    margin-top: 0;
    font-size: 12px;
    color: #ccc;
`
class Equation extends React.Component {
  render() {
    let equation = this.props.equation;
    let math_type = this.props.math_type;
    if (!equation) return null;
    equation = equation.toString();
    // console.log(this.props.answered)
    let color = this.props.answered ? 'white' : 'black';
    return (
      <div className="equation" style={{color : color}}>
        {
          this.props.blooms &&
          <MQNo>Level - {this.props.blooms}</MQNo>
        }
        {math_type == 0 &&
          <span dangerouslySetInnerHTML={{ __html: equation }} />
        }
        {math_type == 1 &&
          <Latex >{equation}</Latex>
        }
        <style jsx scoped>{`
          .equation{
            font-size: 13px;
            font-weight: 400;
            line-height: 20.83px;
            margin-bottom:10px;
            word-break: break-word;
            font-weight: ${ 'bold' in this.props ? this.props.bold : 'none'};
          }
        `}
        </style>
      </div>
    )
  }
}
export default Equation;